module.exports = __webpack_public_path__ + "static/media/D6.7a1be3ee.png";